<template>
  <div class="d-inline-flex">
    <button
      v-if="currentSubscription"
      type="button"
      class="app-header__chip"
      @click="$bvModal.show('show-sub-attiva-info')"
    >
      <b-icon icon="info-circle" aria-hidden="true"></b-icon>
      <span class="app-header__chip-label">{{$t('StatoSottoscrizioniProfilo.sottoscrizione_attiva')}}</span>
      <strong>{{ currentSubscription.nome }}</strong>
    </button>
    <b-modal
      id="show-sub-attiva-info"
      size="md"
      :title="$t('cosa_prevede_sottoscrizione')"
      centered
      hide-footer
      scrollable
    >
      <template v-if="currentSubscription">
        <SubscriptionDetailModal
          v-if="currentSubscription.slug === 'con-cura-free'"
          :gratuito="pianoGratuito"
          :slug-corrente="currentSubscription.slug"
        />
        <SubscriptionDetailModal
          v-else
          :piani="[currentSubscription]"
          :slug-corrente="currentSubscription.slug"
        />
      </template>
    </b-modal>
  </div>
</template>

<script>
import { cittadinoService } from "@/_services";
import { mapActions } from "vuex";
import SubscriptionDetailModal from "@/app/modules/sottoscrizioni/components/SubscriptionDetailModal.vue";

import moment from "moment";

export default {
  name: "HeaderRecapSottoscrizioniPaziente",
  data() {
    return {
      innerWidth: window.innerWidth,
      currentSubscription: null,
      condizioniGenerali: null,
      pendingSubscription: null,
      availableSubscriptions: null,
      collapses: {},
      currentCollapse: false,
      allCollapsesAreClosed: true,
      convenzioni: [
        {
          name: "ConCura & UnoBravo",
          description: null,
          logo: require(`@/assets/common/unobravo_logo.svg`),
        },
        {
          name: "ConCura & Parentsmile",
          description: null,
          logo: require(`@/assets/common/parentsmile_logo.jpg`),
        },
      ],
    };
  },
  components: {
    SubscriptionDetailModal,
  },
  computed: {
    // Il piano gratuito con le condizioni generali dell'API (il dettaglio con i
    // prezzi scritti a mano in FreeSubscription non si usa: invecchiava)
    pianoGratuito() {
      return {
        ...this.currentSubscription,
        dettaglio: "",
        descrizione: this.$t("PlanSheet.descrizioneGratuito"),
        condizioni: this.condizioniGenerali,
      };
    },
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    getUserSubscriptions() {
      const self = this;
      const filters = { service_ref: 8 };
      cittadinoService
        .getOwnSubscriptions(filters, this.$route.query.hashid)
        .then(function (res) {
          const subscriptions = res.data.data;
          self.condizioniGenerali = subscriptions.condizioni_generali || null;
          self.currentSubscription = subscriptions.attivo
            ? subscriptions.attivo.abbonamento
            : self.getFreeSubscription();
        })
        .catch(function (err) {
          console.error(err);
          self.errorAlert(self.$t("errore_operazione"));
        });
    },
    getFreeSubscription() {
      const freeSubscription = {
        nome: "ConCura FREE",
        slug: "con-cura-free",
        prezzo: 0,
        descrizione: this.$t('FreeSubscription.descrizione'),
        dettaglio: this.$t('FreeSubscription.dettaglio')
      };
      return freeSubscription;
    },
  },
  created() {
    this.getUserSubscriptions();
    this.getFreeSubscription();
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  .price_huge_font,
  .fs-5 {
    /* display: block; */
    text-align: right;
    margin-top: 1rem;
  }
}
</style>
